var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVideoOff(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M22.844 26.47a.77.77 0 0 0 .552-.218.77.77 0 0 0 .219-.552.736.736 0 0 0-.22-.542L3.98 5.762a.719.719 0 0 0-.542-.229c-.215 0-.399.077-.552.23a.742.742 0 0 0-.218.546c0 .22.073.401.218.547l19.417 19.396a.736.736 0 0 0 .542.219zm-1.782-5.343c.035-.153.06-.325.073-.516.014-.19.021-.38.021-.567v-8.938c0-1.02-.27-1.81-.812-2.37-.542-.559-1.33-.838-2.365-.838H7.823l13.24 13.23zm6.146 1.417c.382 0 .695-.13.938-.39.243-.261.364-.6.364-1.017V10.816c0-.417-.121-.754-.364-1.01-.243-.258-.556-.386-.938-.386-.201 0-.4.048-.599.146a3.051 3.051 0 0 0-.588.385l-2.948 2.54a1.5 1.5 0 0 0-.52 1.137v4.7c0 .435.188.85.518 1.134l2.95 2.552c.194.16.39.288.588.385.198.097.398.146.6.146zm-8.833 1.49L4.344 10.012c-.049.131-.089.3-.12.505a4.104 4.104 0 0 0-.047.62v9.708c0 1.014.285 1.798.854 2.354.57.556 1.372.833 2.407.833h10.937z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoOff);
export default __webpack_public_path__ + "static/media/video-off.42248314.svg";
export { ForwardRef as ReactComponent };